const { produce } = require("immer");
const permissions = require("./permissions");

const init = {
  group: {
    name: null,
    type: null,
    address: "",
    email: "",
    phone: ""
  },
  admin: {
    login: null,
    password: null
  },
  profile: {
    type: "admin",
    permissions: Object.keys(permissions).reduce((acc, k) => {
      acc[k] = true;
      return acc;
    }, {})
  }
}

module.exports = function (state = init, action) {
  switch(action.type) {
    case "SET_groupForm":
      return produce(state, draft => {
        Object.assign(draft.group, action.form)
      });

    case "UPDATE_groupForm":
      return produce(state, draft => {
        if(action.form.group) Object.assign(draft.group, action.form.group);
        if(action.form.profile) {
          Object.assign(draft.profile, action.form.profile);
          if(action.form.profile.permissions) Object.assign(draft.profile.permissions, action.form.profile.permissions);
        }
        if(action.form.admin) Object.assign(draft.admin, action.form.admin);
      });

    case "RESET_groupForm":
      return init;

    default:
      return state;
  }
}
